@if (cubemapFacesSig(); as cubemapFaces) {
  <nrc-marzipano-scene class="w-full h-full"
    [faces]="cubemapFaces"
    (sceneReady)="onSceneReady($event)"
  />

  <!-- Area elements as hotspots through nrcSceneHotspot -->
  @if (marzipanoScene && currentLanguageCode && areaElements) {
  <div class="relative flex flex-col w-full h-full pointer-events-none">
    @for (areaElement of areaElements; let i = $index; track trackByIdAndIndex(i, areaElement)) {
      @if (!areaElement.markedForDeletion) {
        <div
          #hotspotElement
          nrcSceneHotspot
          [scene]="marzipanoScene"
          [hotspotId]="areaElement.id"
          [boundingBox]="areaElement.boundingBox"
          [isNew]="!!areaElement.markedForCreation && !areaElement.boundingBox.spherical"
          [zIndex]="(areaElements.length + 1) - i"
          [parentContainer]="parentContainer"
          [isVisible]="areaElement.isEnabled && !areaElement.markedForDeletion"
          [isDraggable]="selectedAreaElementConfig?.id === areaElement.id && !areaElement.isLocked"
          [isTransformable]="selectedAreaElementConfig?.id === areaElement.id && !areaElement.isLocked"
          (boundingBoxChanged)="onHotspotBoundingBoxChanged(areaElement, $event)"
          (hotspotClick)="areaElementClickedEvent.emit(areaElement)"
          (hotspotDoubleClick)="areaElementDblClickedEvent.emit(areaElement)"
          (hotspotClickOutside)="areaElementClickOutsideEvent.emit()"
        >
          <nrc-area-element
            #areaElementContainer
            class="hotspot-content"
            [languageCode]="currentLanguageCode"
            [parentContainerElement]="parentContainer?.nativeElement"
            [isResizable]="false"
            [apiBaseUrl]="apiBaseUrl"
            [areaElement]="areaElement"
            [editMode]="true"
          />
        </div>
      }
    }
  </div>
  }
}
